import React, { PureComponent } from 'react';
import ButtonItem from './ButtonItem';
import {APP_CONFIG} from '../../../utils/config'
import {openUrl} from '../../../utils/utils'
class ListCard extends PureComponent {

    constructor(props) {
        super(props);
    }

    link(url) {
        openUrl(url, APP_CONFIG.popWinTarget, this.props.fromApp)

        /*
        const popWin = window.open(url, APP_CONFIG.popWinTarget)
        popWin.focus()
        */
    }

    removeHighlightTags(data) {
        return data.replace(/<!HS>/g, '').replace(/<!HE>/g,'');
    }

    render() {
        
        let {header, items} = this.props.data;
        const buttons = (<ButtonItem data={this.props.data.buttons} fromApp={this.props.fromApp}/>)
        return (
            <div className="bubble_box">
            <div className="bubble_unit">
                { header.title &&
                <strong className="notice_tit" tabIndex={0}><span className="ico_comm ico_calendar"></span>{ header.title }</strong>
                }
                <ul className="notice_list">
                    { items.map (
                        (item, index) => (
                            <li className="notice_item" key={index}>
                            { item.link 
                                ? item.link.web !== null && item.link.web !== "" 
                                    && <a href="#none" className="notice_link" onClick={() => {this.link(item.link.web)}} title="새창열림">{ this.removeHighlightTags(item.title) }<span className="date_txt">{item.description}</span></a>
                                : <a href="#none" className="notice_link" >{this.removeHighlightTags(item.title)}<span className="date_txt">{item.description}</span></a>
                            }     
                            </li>
                        )
                    )}
                </ul>
                { buttons }
            </div>
            </div>
        );
    }
    /*

    */
};

export default ListCard;